import { useFolderBrowser } from "../hooks/useFolderBrowser";
import { FolderBrowser } from "../../components/FolderBrowser";
import styles from "../../components/FilesModule.module.css";

interface OneDrivePanelProps {
  readonly graphToken: string | null;
}

export function OneDrivePanel({ graphToken }: Readonly<OneDrivePanelProps>) {
  const browser = useFolderBrowser(graphToken, "/me/drive", "OneDrive");

  if (!graphToken) {
    return <div className={styles.empty}>Sign in to access your files.</div>;
  }

  return (
    <FolderBrowser
      items={browser.items}
      loading={browser.loading}
      error={browser.error}
      path={browser.path}
      emptyMessage="No files in this folder."
      onBreadcrumbClick={browser.navigateTo}
      onFolderClick={browser.navigateInto}
    />
  );
}
